/**
 * Swaps the product breadcrumb trail for a link back to the search results
 * when the shopper arrived from a search page (Searchanise or native /search).
 * Remembered per product for the session so reloads keep the crumb.
 */
(() => {
  const SEARCH_PATHS = ['/pages/search-results-page', '/search'];
  const STORAGE_KEY = 'searchBreadcrumb';
  const container = document.querySelector('[data-dynamic-product-content="breadcrumbs"]');
  if (!container) return;

  const label = container.dataset.searchLabel || 'Search';
  const productPath = window.location.pathname;

  const readStore = () => {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  };

  const getSearch = () => {
    let referrer;
    try {
      referrer = document.referrer ? new URL(document.referrer) : null;
    } catch (e) {
      referrer = null;
    }

    const fromSearch = referrer
      && referrer.origin === window.location.origin
      && SEARCH_PATHS.includes(referrer.pathname.replace(/\/$/, ''))
      && referrer.searchParams.get('q');

    if (fromSearch) {
      const search = { url: referrer.pathname + referrer.search, q: referrer.searchParams.get('q') };
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readStore(), [productPath]: search }));
      } catch (e) {
        // Storage unavailable; crumb still applies for this page view
      }
      return search;
    }

    return readStore()[productPath] || null;
  };

  const search = getSearch();
  if (!search) return;

  const apply = () => {
    const list = container.querySelector('.breadcrumbs-list');
    if (!list || list.dataset.searchCrumb) return;
    const items = list.querySelectorAll('.breadcrumbs-list__item');
    if (items.length < 2) return;

    // Middle crumbs (collection) are replaced; home and product are kept
    const divider = items[0].querySelector('.icon');
    for (let i = 1; i < items.length - 1; i += 1) items[i].remove();

    const item = document.createElement('li');
    item.className = 'breadcrumbs-list__item';
    const link = document.createElement('a');
    link.className = 'breadcrumbs-list__link';
    link.href = search.url;
    link.textContent = `${label}: "${search.q}"`;
    item.append(link, ' ');
    if (divider) item.append(divider.cloneNode(true));
    list.insertBefore(item, items[items.length - 1]);
    list.dataset.searchCrumb = 'true';
  };

  apply();
  // Breadcrumbs are re-rendered when switching between combined-listing products
  new MutationObserver(apply).observe(container, { childList: true, subtree: true });
})();
